import { HostListener, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface IComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export abstract class ComponentCanDeactivate
  implements IComponentCanDeactivate {
  abstract canDeactivate(): Observable<boolean> | boolean;

  // @HostListener allows us to guard against browser refresh, close, etc.
  @HostListener('window:beforeunload', ['$event'])
  public unloadNotification($event: { returnValue: boolean }) {
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
